{
  "endTime": "Sluttidspunkt",
  "startTime": "Starttidspunkt",
  "time": "Klokkeslæt"
}
